// extracted by mini-css-extract-plugin
export default {"files-list":"N8pHzD4qYEBeW0O"};